import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=0c8833b1&scoped=true"
import script from "./edit.js?vue&type=script&lang=js&external"
export * from "./edit.js?vue&type=script&lang=js&external"
import style0 from "./edit.vue?vue&type=style&index=0&id=0c8833b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8833b1",
  null
  
)

export default component.exports